import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import * as React from 'react';
import { httpClient } from '../../../../../api/http/http-client';
import { digitalAccountApiUrl } from '../../../../../constants/enviroments';
import { DIGITAL_ACCOUNT_ROUTES } from '../../../../../constants/routes';
import { useCustomMutation } from '../../../../../hooks/digital/useMutation';
import { useCustomQuery } from '../../../../../hooks/digital/useQuery';
import { VideoCallFrameResponse } from '../../../../../shared/types/digital-account/steps';
import { useDigitalContext } from '../../../../../context/digital';
import { useCustomNavigate } from '../../../../../utils/customHooks/useCustomNavigate';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function VideoCallFrame() {
  const newWindow = React.useRef<Window | null>(null);
  const { state } = useDigitalContext();
  const [status, setStatus] = React.useState<string>('');
  const [polling, setPolling] = React.useState<boolean | null>(false);
  const navigate = useCustomNavigate();

  const {
    mutate,
    data: frameData,
    isLoading,
  } = useCustomMutation(
    async (): Promise<VideoCallFrameResponse> =>
      await httpClient.post(
        `${digitalAccountApiUrl}/onboarding?business_key=${state.business_key}&access_token=${state.business_key}`,
        {
          action: 'get_videocall_url',
        }
      )
  );

  useCustomQuery({
    queryKey: ['check_call_result'],
    queryFn: async (): Promise<VideoCallFrameResponse> =>
      await httpClient.post(
        `${digitalAccountApiUrl}/onboarding?business_key=${state.business_key}&access_token=${state.business_key}`,
        {
          action: 'check_call_result',
        }
      ),

    refetchInterval: 1000,
    enabled: polling && status !== 'success',
    options: {
      onSuccess: data => {
        if (status !== data.result) {
          setStatus(data.result);
        }

        if (!polling) return;

        switch (data.result) {
          case 'success':
            setPolling(false);
            setStatus('');
            navigate(
              `${DIGITAL_ACCOUNT_ROUTES.base}/${DIGITAL_ACCOUNT_ROUTES['request-accepted']}`
            );
            break;
          case 'videocall_failed_successfully':
            setPolling(false);
            navigate(`${DIGITAL_ACCOUNT_ROUTES.base}/${DIGITAL_ACCOUNT_ROUTES['identify-failed']}`);
            break;
          default:
            break;
        }
      },
      onError: (error: any) => {
        if (error.response.data.error.id === 'videocall_failed_successfully') {
          setPolling(false);
          setStatus('');
          navigate(`${DIGITAL_ACCOUNT_ROUTES.base}/${DIGITAL_ACCOUNT_ROUTES['identify-failed']}`);
        }
      },
    },
  });

  const handleClickOpen = () => {
    mutate(undefined, {
      onSuccess: response => {
        if (response?.frame_url) {
          const element = document.createElement('a');
          element.href = response.frame_url;
          element.target = '_blank';
          element.rel = 'noopener noreferrer';
          setPolling(true);
          element.click();
          // newWindow.current = window.open(
          //   response?.frame_url,
          //   '_blank',
          //   `width=${window.screen.availWidth},height=${window.screen.availHeight},top=0,left=0`
          // );
        }
      },
    });
  };

  return (
    <React.Fragment>
      <Button
        disabled={isLoading || status === 'wait'}
        sx={{ marginTop: '24px', padding: '16px !important' }}
        onClick={handleClickOpen}
      >
        {status === 'wait' ? 'Video zəngə qoşuldu' : 'Video zəngə indi qoşul'}
      </Button>
      {/* <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <Box sx={{ width: '100%', height: '100%', overflow: 'hidden' }}>
          <iframe
            src={frameData?.frame_url}
            id='inlineFrameExample'
            title='Inline Frame Example'
            width='100%'
            height='100%'
          ></iframe>
        </Box>
      </Dialog> */}
    </React.Fragment>
  );
}
